import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import RegisterHeader from '../../../../components/headers/register-header';
import {Column, Row} from '../../../../components/layout';
import {addToGlobalStyles, setWizard} from '../../../../store/actions';
import './styles.scss';
import colors from '../../../../util/colors';
import {strings} from '../../../../util/strings';
import * as fonts from '../../../../util/fonts';
import AppButton from '../../../../components/app-button';
import {useHistory} from 'react-router-dom';

interface WantToRegisterProps {
  addToGlobalStyles(value: any): any;
  setWizard(value: any): any;
  labels: typeof strings.pt.register;
}

function WantToRegister({
  addToGlobalStyles,
  setWizard,
  labels,
}: WantToRegisterProps) {
  const history = useHistory();
  return (
    <Row>
      <Column className="w-100">
        <RegisterHeader></RegisterHeader>
        <Row className="justify-content-center">
          <p
            className="want-to-register-title pt-2"
            style={{
              ...fonts.XL,
              color: colors.alertRed,
              fontWeight: 'bold',
            }}>
            {labels?.register_wantToRegister}
          </p>
        </Row>
        <Row className="justify-content-center pb-3 pl-2 pr-2">
          <p
            className="forget-passoword-title pt-2"
            style={{
              ...fonts.M,
              color: colors.black,
            }}>
            {labels?.register_noRegistsFound}
          </p>
        </Row>
        <Row className="want-to-register-button-row">
          <AppButton
            className="want-to-register-button"
            variant="secondary"
            onClick={() => {
              history.goBack();
            }}>
            {labels?.register_no}
          </AppButton>
          <Column className="pl-4 pr-4"></Column>
          <AppButton
            className="want-to-register-button"
            variant="secondary"
            onClick={() => history.push('/registo')}>
            {labels?.register_yes}
          </AppButton>
        </Row>
      </Column>
    </Row>
  );
}

const mapStateToProps = ({stringsDefault}: any) => ({
  labels: stringsDefault.value.pt.register,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(WantToRegister)
);
